import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles'
import {bindActionCreators} from 'redux'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import {FusePageSimple} from '../../../../@fuse/index'
import UecareListHeader from "../../../../components/header/UecareListHeader"
import ReduxSurveyCount from "../../../../store/actionreducers/surveyCount"
import SurveyCountList from "./SurveyCountList"
import SurveyFeedbackDialog from "./SurveyFeedbackDialog"
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import { LinearProgress, Tab, Tabs } from '@material-ui/core'
import SurveyChart from "./SurveyChart"

class SurveyCountApp extends Component {

    state = {
        tabValue: 0,
    }

    handleChangeTab = (event, tabValue) => {
        if (this.state.tabValue === tabValue) return
        this.setState({tabValue})
    }

    async componentDidMount() {
        await this._reload()
    }

    async _reload() {
        this.setState({ isLoading: true })
        await this.props.getMissions()
        this.setState({ isLoading: false })
    }

    render() {
        const {classes, surveyCount} = this.props
        const {tabValue} = this.state

        const filteredMissions = surveyCount.list.filter(mission => {
            const {career, fk_status_id } = mission
            return !!career && fk_status_id === 5
        })


        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <UecareListHeader title='App問卷統計' icon='insert_comment' reload={() => this._reload()} />
                    }

                    contentToolbar={
                        <div style={{ width: '100%' }}>
                            <LinearProgress
                                color="secondary"
                                style={{ visibility: this.state.isLoading ? 'visible' : 'hidden' }}
                            />
                            <Tabs
                                value={tabValue}
                                onChange={this.handleChangeTab}
                                indicatorColor="secondary"
                                textColor="secondary"
                                scrollable
                                scrollButtons="auto"
                                classes={{ root: 'w-full h-40' }}
                                className='bg-grey-light'>
                                <Tab className="h-40 normal-case font-extrabold" label="圖表" />
                                <Tab className="h-40 normal-case font-extrabold" label="詳細資訊" />
                            </Tabs>
                        </div>
                    }

                    content={
                        <div className="p-16">
                            {tabValue === 0 && <SurveyChart surveyCount={filteredMissions}/>}
                            {tabValue === 1 && <SurveyCountList surveyCount={filteredMissions}/>}
                        </div>
                    }
                    sidebarInner
                />
                <SurveyFeedbackDialog />
            </React.Fragment>

        )
    }
}


const headerHeight = 160

const styles = theme => ({
    root: {},
    layoutHeader: {
        height: headerHeight,
        minHeight: headerHeight
    },
    layoutContentCardWrapper: {
        padding: 16,
    },
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        getMissions: ReduxSurveyCount.ActionCreator.getMissions,
    }, dispatch)
}

function mapStateToProps({surveyCount: {list}}) {
    return {
        surveyCount: {list}
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(SurveyCountApp)))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/surveyCount/SurveyCountApp.js